import { useCallback, useRef } from 'react';
import { recordPropertyClickedEvent } from '../components/editor/NLPSuggestions/recordPropertyClickedEvent';
import { useEditorActions } from './useEditorActions';
export const useNLPIntegration = ({
  isEnabled,
  searchString,
  filterFamily,
  onSelectField
}) => {
  const {
    selectField
  } = useEditorActions();
  const suggestedPropertiesResultsRef = useRef();
  const showNLPSuggestions = isEnabled && searchString;
  const handleOnSelectField = useCallback((field, usedSemanticSearch = false) => {
    if (onSelectField) {
      onSelectField(filterFamily, field);
    } else {
      var _suggestedPropertiesR;
      if (isEnabled) {
        recordPropertyClickedEvent({
          searchString,
          filterFamily,
          options: suggestedPropertiesResultsRef.current,
          selectedOption: field
        });
      }
      selectField(filterFamily, field, usedSemanticSearch, !!((_suggestedPropertiesR = suggestedPropertiesResultsRef.current) !== null && _suggestedPropertiesR !== void 0 && _suggestedPropertiesR.length));
    }
  }, [onSelectField, filterFamily, isEnabled, searchString, suggestedPropertiesResultsRef, selectField]);
  return {
    showNLPSuggestions,
    handleOnSelectField,
    suggestedPropertiesResultsRef
  };
};